import React from 'react';
import FieldHelpIcon from '../../../components/common/FieldHelpIcon';

const CareLinkFieldLabel = ({ htmlFor, label, help, required = false }) => (
  <label htmlFor={htmlFor} className="crud-field-label">
    <span>
      {label}
      {required ? <span className="required-field"> *</span> : null}
    </span>
    <FieldHelpIcon help={help} />
  </label>
);

export default CareLinkFieldLabel;
